module.exports = __webpack_public_path__ + "img/LazyLovers.bf79063d.png";